import CryptoJs from "crypto-js";

export function getKey(key) {
    var ke = CryptoJs.enc.Utf8.parse(key);
    var iv = CryptoJs.enc.Utf8.parse(key);
    return { key: ke, iv: iv };
}

export function encrypt(data, key) {
    let secretKey = getKey(key);
    let options = {
        mode: CryptoJs.mode.CBC,
        iv: secretKey.iv
    };
    let payload = typeof data == 'object' ? JSON.stringify(data) : data;
    let json = CryptoJs.AES.encrypt(payload.toString(CryptoJs.enc.Utf8), secretKey.key, options);
    return json.toString();
}


export function decrypt(data, key) {
    let secretKey = getKey(key);
    let options = {
        mode: CryptoJs.mode.CBC,
        iv: secretKey.iv
    };
    let dataDecrypt = data;
    let decrypted = CryptoJs.AES.decrypt(dataDecrypt, secretKey.key, options);

    let result = decrypted.toString(CryptoJs.enc.Utf8);
    return result;
}

